module.exports = __webpack_public_path__ + "static/img/son6.b49a2a26.png";